import { render } from "./PQRPage.vue?vue&type=template&id=697d5b57"
import script from "./PQRPage.vue?vue&type=script&lang=js"
export * from "./PQRPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__